import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import {
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '@src/components/shadcn/sidebar';
import {CollapsibleContent, CollapsibleTrigger} from '@src/components/shadcn/collapsible';
import {Collapsible} from '@radix-ui/react-collapsible';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronRight} from '@fortawesome/pro-light-svg-icons';
import {NavItem, SubNavItem} from './types';

const CollapsibleData = ({options}: {options: SubNavItem[]}) => {
  return (
    <CollapsibleContent>
      <SidebarMenuSub>
        {options.map(({label, to, isLinkToActiveApp, isActive}) => {
          return (
            <SidebarMenuSubItem key={to}>
              <SidebarMenuSubButton className="pl-3" size="lg" asChild isActive={isActive}>
                {isLinkToActiveApp ? (
                  <Link to={to}>
                    <span className="text-base">{label}</span>
                  </Link>
                ) : (
                  <a href={to}>
                    <span className="text-base">{label}</span>
                  </a>
                )}
              </SidebarMenuSubButton>
            </SidebarMenuSubItem>
          );
        })}
      </SidebarMenuSub>
    </CollapsibleContent>
  );
};

const CollapsibleLink = ({
  item,
}: {
  item: Omit<NavItem, 'subNavItems'> & {subNavItems: SubNavItem[]};
}) => {
  const haveActiveSublink = item.subNavItems.find(({isActive}) => isActive);
  const [open, setOpen] = useState(!!haveActiveSublink);

  const handleOpenChange = () => {
    if (haveActiveSublink) return;
    setOpen(prev => !prev);
  };

  return (
    <Collapsible open={open} onOpenChange={handleOpenChange} asChild className="group/collapsible">
      <SidebarMenuItem>
        <CollapsibleTrigger asChild className="cursor-pointer">
          <SidebarMenuButton asChild>
            <div>
              <div className="flex justify-between items-center">
                {item.icon && (
                  <FontAwesomeIcon
                    icon={item.icon}
                    className="text-textPrimary w-5 h-5 transition-transform mr-2"
                  />
                )}

                <span className="text-textPrimary">{item.label}</span>
              </div>
              <FontAwesomeIcon
                icon={faChevronRight}
                className="ml-auto text-textPrimary h-3 transition-transform group-data-[state=open]/collapsible:rotate-90"
              />
            </div>
          </SidebarMenuButton>
        </CollapsibleTrigger>
        <div className="pl-2">
          <CollapsibleData options={item.subNavItems} />
        </div>
      </SidebarMenuItem>
    </Collapsible>
  );
};

export default CollapsibleLink;
